import { useEffect } from 'react';
export const META_PIXEL_ID = '2525589844506080';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
const PAGEVIEW_FLAG = '__metaPixelPageViewSent';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const flagged = window as unknown as Record<string, boolean>;
    if (flagged[PAGEVIEW_FLAG]) return;
    flagged[PAGEVIEW_FLAG] = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args);
        } else {
          fbq.queue?.push(args);
        }
      } as NonNullable<Window['fbq']>;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq?.('init', META_PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-144" data-mp="1deus7utqw8zp">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-145" data-mp="1debkf6xt70ze" />
    </noscript>;
}